import { useState } from "react";
import { X, UserPlus } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export function AddCustomerDialog({ onClose, onAdded }) {
  const [form, setForm] = useState({ name: "", location: "", id_type: "aadhaar", id_number: "" });
  const [saving, setSaving] = useState(false);
  const setF = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    if (!form.name.trim() || !form.location.trim() || !form.id_number.trim()) {
      toast.error("Name, location and Aadhaar/GST number are required");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.post("/customers", form);
      toast.success(`Customer "${data.name}" added`);
      onAdded(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  const input = "mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none transition-colors duration-150 focus:border-slate-900";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4" data-testid="add-customer-dialog">
      <div className="w-full max-w-md rounded-lg bg-white p-5 shadow-xl">
        <div className="flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
            <UserPlus size={18} weight="duotone" /> Add New Customer
          </h2>
          <button data-testid="add-customer-close" onClick={onClose} className="text-slate-400 hover:text-slate-900"><X size={18} /></button>
        </div>
        <p className="mt-1 text-xs text-slate-500">Aadhaar or GST number is required so the customer master stays clean — no duplicates allowed.</p>
        <div className="mt-4 space-y-3">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Customer Name *</label>
            <input data-testid="add-customer-name" value={form.name} onChange={setF("name")} placeholder="e.g. Sharma Traders" className={input} />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Location *</label>
            <input data-testid="add-customer-location" value={form.location} onChange={setF("location")} placeholder="City / area" className={input} />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">ID Type *</label>
              <select data-testid="add-customer-id-type" value={form.id_type} onChange={setF("id_type")}
                className="mt-1 w-full rounded-md border border-slate-300 bg-white px-2 py-2 text-sm outline-none">
                <option value="aadhaar">Aadhaar</option>
                <option value="gst">GST</option>
              </select>
            </div>
            <div className="col-span-2">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                {form.id_type === "gst" ? "GST Number (15 chars) *" : "Aadhaar Number (12 digits) *"}
              </label>
              <input data-testid="add-customer-id-number" value={form.id_number} onChange={setF("id_number")}
                placeholder={form.id_type === "gst" ? "22AAAAA0000A1Z5" : "123412341234"} className={input} />
            </div>
          </div>
          <div className="flex justify-end gap-2 border-t border-slate-200 pt-4">
            <button data-testid="add-customer-cancel" onClick={onClose}
              className="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100">Cancel</button>
            <button data-testid="add-customer-save" onClick={save} disabled={saving}
              className="rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700 disabled:opacity-60">
              {saving ? "Adding…" : "Add customer"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
